export const SYNCHRONIZATIONS_VALIDATION_RULES = {
  billingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/synchronizations/synchronizationsValidationRules.js